import { ActionIcon, Button, Flex, Image, Modal, Text } from "@mantine/core";

export interface WarningModalProps {
  opened: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  text: string;
  confirmText: string;
  cancelText: string;
}

// Purposefully left this modal as flexible and reusable as possible
// so actions + text can be passed in as props
export const WarningModal = ({
  opened,
  onConfirm,
  onCancel,
  title,
  text,
  confirmText,
  cancelText,
}: WarningModalProps) => {
  return (
    <Modal opened={opened} onClose={onCancel} withCloseButton={false}>
      <Flex align="flex-start" direction="column" gap={16}>
        <Flex align="center" className="w-full" justify="space-between">
          <Text fw={600}>{title}</Text>
          <ActionIcon onClick={onCancel} variant="transparent">
            <Image
              src="/assets/circle-x.svg"
              alt="Close Warning Modal"
              h={16}
            />
          </ActionIcon>
        </Flex>
        <Text>{text}</Text>
        <hr className="w-full my-4" />
        <Flex justify="space-between" gap={16}>
          <Button onClick={() => onConfirm()} color="red.3">
            {confirmText}
          </Button>
          <Button onClick={onCancel} className="text-uw-gray-9" color="gray.0">
            {cancelText}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
